/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '@ngx-translate/core/src/translate.pipe';
import * as i2 from '@ngx-translate/core/src/translate.service';
import * as i3 from '../../../../src/app/components/support.component';
var styles_SupportComponent = [];
export var RenderType_SupportComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_SupportComponent, data: {} });
export function View_SupportComponent_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 22, 'div', [['class',
                'clearfix support-col']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'col-xs-12 col-sm-6 support-link']], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 5, 'a', [['target', '_blank']], [[8, 'href', 4]], null, null, null, null)), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'icon-block fa fa-3x fa-mobile']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n    '])),
        (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'col-xs-12 col-sm-6 support-link']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 5, 'a', [['target',
                '_blank']], [[8, 'href', 4]], null, null, null, null)),
        i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'icon-block fa fa-2x fa-envelope-o']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n'])),
        (_l()(), i0.ɵted(null, ['\n']))], null, function (_ck, _v) {
        var currVal_0 = i0.ɵinlineInterpolate(1, '', i0.ɵunv(_v, 4, 0, i0.ɵnov(_v, 5).transform('ORDER.MAIN_COMPONENT.HELPDESK.CALL_US_URL')), '');
        _ck(_v, 4, 0, currVal_0);
        var currVal_1 = i0.ɵunv(_v, 8, 0, i0.ɵnov(_v, 9).transform('ORDER.MAIN_COMPONENT.HELPDESK.CALL_US'));
        _ck(_v, 8, 0, currVal_1);
        var currVal_2 = i0.ɵinlineInterpolate(1, '', i0.ɵunv(_v, 15, 0, i0.ɵnov(_v, 16).transform('ORDER.MAIN_COMPONENT.HELPDESK.EMAIL_US_URL')), '');
        _ck(_v, 15, 0, currVal_2);
        var currVal_3 = i0.ɵunv(_v, 19, 0, i0.ɵnov(_v, 20).transform('ORDER.MAIN_COMPONENT.HELPDESK.EMAIL_US'));
        _ck(_v, 19, 0, currVal_3);
    });
}
export function View_SupportComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'cx-support', [], null, null, null, View_SupportComponent_0, RenderType_SupportComponent)),
        i0.ɵdid(49152, null, 0, i3.SupportComponent, [], null, null)], null, null);
}
export var SupportComponentNgFactory = i0.ɵccf('cx-support', i3.SupportComponent, View_SupportComponent_Host_0, {}, {}, []);
//# sourceMappingURL=support.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./aot/src/app/components/support.component.ngfactory.js
// module id = 814
// module chunks = 0